import React from 'react';
import DeliveryRequest from '../../pages/DeliveryRequest';

const DrUserWrapperLayout = () => {
    return (
        <div className="md:px-6 sm:px-3 pt-4">
            <div className="flex items-center justify-center w-full max-w-7xl">
                <div className="bg-card-color rounded-xl sm:p-4 p-2 w-full shadow-shadow-sm border border-dashed border-border-color">
                    <div className="sm:p-4 p-3 overflow-auto custom-scrollbar">
                        <DeliveryRequest />
                    </div>
                </div>
            </div>
        </div >
    );
};

export default DrUserWrapperLayout;
